/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoItemStatisticsItemData model module.
 * @module model/PerplayStatisticsControllerDtoItemStatisticsItemData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoItemStatisticsItemData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoItemStatisticsItemData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoItemStatisticsItemData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoItemStatisticsItemData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoItemStatisticsItemData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoItemStatisticsItemData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoItemStatisticsItemData} The populated <code>PerplayStatisticsControllerDtoItemStatisticsItemData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoItemStatisticsItemData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('totalItemCount')) {
                obj['totalItemCount'] = ApiClient.convertToType(data['totalItemCount'], 'Number');
            }
            if (data.hasOwnProperty('newItemCount')) {
                obj['newItemCount'] = ApiClient.convertToType(data['newItemCount'], 'Number');
            }
            if (data.hasOwnProperty('burnedItemCount')) {
                obj['burnedItemCount'] = ApiClient.convertToType(data['burnedItemCount'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoItemStatisticsItemData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoItemStatisticsItemData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoItemStatisticsItemData.prototype['targetDate'] = undefined;

/**
 * @member {Number} totalItemCount
 */
PerplayStatisticsControllerDtoItemStatisticsItemData.prototype['totalItemCount'] = undefined;

/**
 * @member {Number} newItemCount
 */
PerplayStatisticsControllerDtoItemStatisticsItemData.prototype['newItemCount'] = undefined;

/**
 * @member {Number} burnedItemCount
 */
PerplayStatisticsControllerDtoItemStatisticsItemData.prototype['burnedItemCount'] = undefined;






export default PerplayStatisticsControllerDtoItemStatisticsItemData;

